import { defineMessage } from 'react-intl';
export const COMPUTER_EFFORT_MENU_WIDTH_PX = 270;
export const HarnessMode = {
    INSTANT: 'instant',
    LIGHT: 'light',
    STANDARD: 'standard',
    HIGH: 'high',
    ULTRA: 'ultra',
};
const HARNESS_MODE_MESSAGES = {
    [HarnessMode.INSTANT]: defineMessage({
        defaultMessage: 'Instant',
        id: 'aca6ab5715',
        description: 'Label for the Computer mode focused on quick answers and simple searches.',
    }),
    [HarnessMode.LIGHT]: defineMessage({
        defaultMessage: 'Light',
        description: 'Label for the lowest Computer effort option in a Light, Standard, High, Ultra scale. Translate Light as a low effort/intensity level, not an appearance theme, physical weight, or model intelligence.',
        id: 'd998b39eff',
    }),
    [HarnessMode.STANDARD]: defineMessage({
        defaultMessage: 'Standard',
        description: 'Label for the second Computer effort option in a Light, Standard, High, Ultra scale. Translate Standard as the regular effort level, not a technical standard or model quality rating.',
        id: 'ee5f82eba6',
    }),
    [HarnessMode.HIGH]: defineMessage({
        defaultMessage: 'High',
        description: 'Label for the third Computer effort option in a Light, Standard, High, Ultra scale. Translate High as high effort/intensity, not physical height or model intelligence.',
        id: 'c4dce6ba7b',
    }),
    [HarnessMode.ULTRA]: defineMessage({
        defaultMessage: 'Ultra',
        description: 'Label for the highest Computer effort option in a Light, Standard, High, Ultra scale. Translate Ultra as the maximum effort/intensity level.',
        id: 'be1b6665a9',
    }),
};
export const resolveHarnessModeDisplayStrings = ({ mode, intl, apiStrings, }) => {
    if (apiStrings?.label && apiStrings.subtitle_template?.split('{model}').length === 2) {
        return {
            label: apiStrings.label,
            subtitle_template: apiStrings.subtitle_template,
        };
    }
    return {
        label: intl.$t(HARNESS_MODE_MESSAGES[mode]),
    };
};
//# sourceMappingURL=ComputerPresetsShared.js.map